import React, { Component } from 'react'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_VOLCADORAS_CON_CEREAL_ASIGNADO } from '../../../../../config/tables'

export class TablaVolcadorasConCerealAsignadoView extends Component {
  render () {
    return (
      <MuiTable id={TABLA_VOLCADORAS_CON_CEREAL_ASIGNADO} />
    )
  }
}
